export const clinicalSpecialty = [
  {
    id: 14,
    name: 'Ob/Gyn',
    description: null,
    createdAt: '2020-07-15T23:07:03.550Z',
    updatedAt: '2020-07-15T23:07:03.550Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 5,
    name: 'Diabetes',
    description: null,
    createdAt: '2019-09-09T20:48:56.769Z',
    updatedAt: '2019-09-09T20:48:56.769Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 4,
    name: 'Obesity',
    description: '',
    createdAt: '2019-09-09T20:48:56.768Z',
    updatedAt: '2022-05-11T09:37:08.325Z',
    createdBy: null,
    updatedBy: 1,
  },
  {
    id: 2,
    name: 'Gastroenterology',
    description: null,
    createdAt: '2019-09-09T20:48:56.768Z',
    updatedAt: '2022-01-26T06:13:51.295Z',
    createdBy: null,
    updatedBy: 1,
  },
  {
    id: 7,
    name: 'Cardiology',
    description: null,
    createdAt: '2019-09-09T20:48:56.769Z',
    updatedAt: '2021-07-21T09:34:12.625Z',
    createdBy: null,
    updatedBy: 1,
  },

  {
    id: 9,
    name: 'Nephrology',
    description: null,
    createdAt: '2019-09-09T20:48:56.769Z',
    updatedAt: '2019-09-09T20:48:56.769Z',
    createdBy: null,
    updatedBy: null,
  },

  {
    id: 1,
    name: 'Internal Medicine',
    description: null,
    createdAt: '2019-09-09T20:48:56.768Z',
    updatedAt: '2019-09-09T20:48:56.768Z',
    createdBy: null,
    updatedBy: null,
  },
];
